import { ThemeUICSSObject } from '@apia/theme';
import gantt from './gantt';
import list from './list';
/* IMPORT HERE */

const processes: ThemeUICSSObject = {
  list,
  gantt,
  /* PREPEND HERE */
};

export default processes;
